
import React from 'react';
import PropTypes from 'prop-types';

import DashboardButton from './DashboardButton';
import DashboardRow from './DashboardRow';
import DashboardColumn from './DashboardColumn';

const Dashboard = props => {
    return (
        <div className={`dashboard ${props.mobileShow ? "mobileShow" : "mobileHide"}`}>
            {props.children}
        </div>
    );
};

Dashboard.Button = DashboardButton;
Dashboard.Row = DashboardRow;
Dashboard.Col = DashboardColumn;

Dashboard.propTypes = {
    children: PropTypes.node,
};

export default Dashboard;